export const TOOL_PART_TYPE_PREFIX = "tool-"

export function isToolPart(part) {
  return part.type === "dynamic-tool" || part.type.startsWith(TOOL_PART_TYPE_PREFIX)
}
